import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ModulePermissionService } from '../module-permission.service';
import { ModulePermissionAddPayload } from '../module-permission.interface';
import { helper } from 'src/environments/helper';

@Component({
  selector: 'app-add-module-permission',
  templateUrl: './add-module-permission.component.html',
  styleUrls: ['./add-module-permission.component.scss'],
})
export class AddModulePermissionComponent {
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;
  helper = helper;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    slug: new FormControl('', [Validators.required]),
    observations: new FormControl('', []),
  });

  constructor(
    private dialogRef: MatDialogRef<AddModulePermissionComponent>,
    private modulePermissionService: ModulePermissionService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.modulePermissionService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, slug, observations } = this.form
      .value as ModulePermissionAddPayload;
    const payload: ModulePermissionAddPayload = {
      name,
      slug,
      observations,
    };

    this.modulePermissionService
      .addModule(payload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            this.errorTitle,
            msg,
            this.errorIcon
          );
        },
      });
  }
}
